/* 
  This is the starting point for sliders.
  This is a nowrap arrows on bottom slider. Should be extended
  and layered with more styles for more complex sliders or 
  customizations needed on a section by section basis.

  Structure for this looks like:
  <script src="{{ 'flickity.js' | asset_url }}" defer></script>
  <script src="{{ 'basic-slider.js' | asset_url }}" defer></script>

  <div class="[section-class-name] basic-slider">
    <basic-slider class="basic-slider__container">
      <div class="basic-slider__slider">
        {% for some in thing %}
          <div class="basic-slider__slider__slide">
        {% endfor %}
      </div>

      <div class="basic-slider__arrows">
        <button class="btn __basic-arrow__prev" disabled aria-label="Previous" type="button">
          {% render 'icon-arrow' %}
        </button>
        <button class="btn __basic-arrow__next" aria-label="Next" type="button">
          {% render 'icon-arrow' %}
        </button>
      </div>
    </basic-slider>
  </div>

*/
if (!customElements.get('basic-slider')) {
  class BasicSlider extends HTMLElement {
    constructor() {
      super();

      this.slidesContainer = this.querySelector(".basic-slider__slider");  
      this.slides = this.querySelectorAll(".basic-slider__slider__slide");  

      this.prevArrow = this.querySelector(".__basic-arrow__prev");
      this.nextArrow = this.querySelector(".__basic-arrow__next");

      this.init();
    }

    init() {
      this.flickity = new Flickity(this.slidesContainer, {
        accessibility: true,
        prevNextButtons: false,
        pageDots: false,
        wrapAround: false,
        contain: true, 
        groupCells: true,
        selectedAttraction: 0.03,
        friction: 0.8,
        setGallerySize: true,
        percentPosition: false,
        imagesLoaded: true,
        cellAlign: "left"
      });

      // arrow click handlers
      this.prevArrow?.addEventListener('click', () => {
        this.flickity.previous(true);
      });

      this.nextArrow?.addEventListener('click', () => {
        this.flickity.next(true);
      });

      // update arrow state on init + change
      this.updateArrows();
      this.flickity.on('select', () => this.updateArrows());
    }

    updateArrows() {
      if (!this.flickity) return;

      const index = this.flickity.selectedIndex;
      const lastIndex = this.flickity.slides.length - 1;

      if (this.prevArrow) {
        if (index === 0){
          this.prevArrow.disabled = true;
          this.prevArrow.classList.add("__disabled");
        } else {
          this.prevArrow.disabled = false;
          this.prevArrow.classList.remove("__disabled");
        }
      }

      if (this.nextArrow) {
        if (index === lastIndex){
          this.nextArrow.disabled = true;
          this.nextArrow.classList.add("__disabled");
        } else {
          this.nextArrow.disabled = false;
          this.nextArrow.classList.remove("__disabled");
        }
      }
    }
  }
  
  customElements.define("basic-slider", BasicSlider);
}
